import { createRouter, createWebHistory } from 'vue-router'

// Middlewares
import authMiddleware from '@/middlewares/auth';
import guestMiddleware from '@/middlewares/guest';

// Views
import DashboardLayout from '@/layouts/dashboard/DashboardLayout'
import DefaultLayout from '@/layouts/default/DefaultLayout'
import HomeView from '@/views/HomeView.vue'
import OnboardingView from '@/views/OnboardingView.vue'



// Routes
import auth from './routes/auth'

// Routes by role
import admin from './routes/admin'
import attendant from './routes/attendant'
import buyer from './routes/buyer'
import exhibitor from './routes/exhibitor'
import sponsor from './routes/sponsor'
import speaker from './routes/speaker'
import app from './routes/app'
import company from './routes/company'


const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'dashboard' }
  },

  {
    path: '/dashboard',
    component: DashboardLayout,
    meta: {
      middleware: ['auth']
    },
    children: [
      {
        name: 'dashboard',
        path: '',
        component: HomeView
      }
    ]
  },

  {
    path: '/onboarding',
    component: DefaultLayout,
    meta: {
      middleware: ['auth']
    },
    children: [
      {
        name: 'onboarding',
        path: '',
        component: OnboardingView
      }
    ]
  },

  ...auth,
  ...app,
  ...admin,
  ...attendant,
  ...buyer,
  ...exhibitor,
  ...sponsor,
  ...speaker,
  ...company,
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(guestMiddleware);
router.beforeEach(authMiddleware);

export default router
